allDeleted_1